export enum StrikesAggergationStyle {
    FromATMStrike,
    CustomUnderlierPrice
}
